var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 0.666748H2.99984C1.71067 0.666748 0.666504 1.71091 0.666504 3.00008V24.0001C0.666504 25.2892 1.71067 26.3334 2.99984 26.3334H14.6665V15.8334H11.1665V12.3334H14.6665V10.4539C14.6665 6.89558 16.4002 5.33342 19.3577 5.33342C20.774 5.33342 21.523 5.43841 21.8777 5.48625V8.83342H19.8605C18.6052 8.83342 18.1665 9.49608 18.1665 10.8377V12.3334H21.8462L21.3468 15.8334H18.1665V26.3334H23.9998C25.289 26.3334 26.3332 25.2892 26.3332 24.0001V3.00008C26.3332 1.71091 25.2878 0.666748 23.9998 0.666748Z",
    fill: "#326164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookProfile);
export default __webpack_public_path__ + "static/media/FacebookProfile.1f69d8e062fe8ef972bc3f7995ca9301.svg";
export { ForwardRef as ReactComponent };